module.exports = __webpack_public_path__ + "public/img/07.b423aa5c.png";